import { render } from "./Toggle.vue?vue&type=template&id=41d53856&scoped=true"
import script from "./Toggle.vue?vue&type=script&lang=js"
export * from "./Toggle.vue?vue&type=script&lang=js"

import "./Toggle.vue?vue&type=style&index=0&id=41d53856&lang=scss&scoped=true"

import exportComponent from "/Users/rantalmor/Desktop/volta-vue/proposal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41d53856"]])

export default __exports__